import { Alinta } from '@alinta-digital/asg';
import { ApolloProvider } from '@apollo/client/';
import { useState } from 'react';
import React from 'react';
import './App.css';

import { config } from './config';
import DirectDebit, { createApolloClient } from './views/DirectDebit';

const apolloClient = createApolloClient(
  config.bffUrl !== undefined ? config.bffUrl : ''
);
function useLoadGTM() {
  const [hasInit, setHasInit] = useState(false);
  if (!hasInit) {
    const buildEnv = process.env.REACT_APP_BUILD_ENV;
    if (buildEnv === 'development') {
      window['dataLayer'] = { push: console.log.bind(console) };
    } else if (
      buildEnv === 'uat' ||
      buildEnv === 'prod' ||
      buildEnv === 'test' ||
      buildEnv === 'train'
    ) {
      (function(w, d, s, l, i) {
        // @ts-expect-error expected
        w[l] = w[l] || [];
        // @ts-expect-error expected
        w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
        // eslint-disable-next-line no-var
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != 'dataLayer' ? '&l=' + l : '';
        // @ts-expect-error expected
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        // @ts-expect-error expected
        f.parentNode.insertBefore(j, f);
      })(
        window,
        document,
        'script',
        'dataLayer',
        process.env.REACT_APP_GOOGLE_TAG_MANAGER_ID
      );
    }
    setHasInit(true);
  }
}

export const App: React.FC = () => {
  useLoadGTM();
  return (
    <ApolloProvider client={apolloClient}>
      <Alinta>
        <DirectDebit />
      </Alinta>
    </ApolloProvider>
  );
};
